import { render, staticRenderFns } from "./TableDatetimeItem.vue?vue&type=template&id=5b2838f6&scoped=true"
import script from "./TableDatetimeItem.vue?vue&type=script&lang=js"
export * from "./TableDatetimeItem.vue?vue&type=script&lang=js"
import style0 from "./TableDatetimeItem.vue?vue&type=style&index=0&id=5b2838f6&scoped=true&lang=css"
import style1 from "./TableDatetimeItem.vue?vue&type=style&index=1&id=5b2838f6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2838f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2838f6')) {
      api.createRecord('5b2838f6', component.options)
    } else {
      api.reload('5b2838f6', component.options)
    }
    module.hot.accept("./TableDatetimeItem.vue?vue&type=template&id=5b2838f6&scoped=true", function () {
      api.rerender('5b2838f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/tableItems/TableDatetimeItem.vue"
export default component.exports